import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";

export const getFAQList = (page = 1, limit = 10, keyword = "") => {
    return api.post(`${adminV1Base}/faq/get`, { page, limit, keyword, sort: -1 });
};

export const createFAQ = (data) => {
    return api.post(`${adminV1Base}/faq/create`, data);
};

export const editFAQ = (data) => {
    return api.post(`${adminV1Base}/faq/edit`, data);
};

export const deleteFAQ = (id) => {
    return api.post(`${adminV1Base}/faq/delete`, { id });
};

export const handleFAQStatus = (id) => {
    return api.post(`${adminV1Base}/faq/handle-status`, { id });
};
